import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { List, OrderedMap } from 'immutable'
import { selectors, actions } from 'modules/queues'


class QueuesPagination extends Component {

  static propTypes = {
    activePage: PropTypes.shape({
      month: PropTypes.number,
      year: PropTypes.number,
    }),
    months: PropTypes.arrayOf(PropTypes.number),
    queues: PropTypes.instanceOf(OrderedMap),
    setQueuePage: PropTypes.func.isRequired,
    years: PropTypes.arrayOf(PropTypes.number),
  }

  getPaginationButtonLabel = (page, date) => {
    switch (date) {
      case 'month':
        return moment({ month: page }).format('MMMM')
      case 'year':
        return moment({ year: page }).format('YYYY')
      default:
        throw new Error('Unrecognized category')
    }
  }

  renderButton = (page, date) => {
    const { activePage, setQueuePage } = this.props
    const setPage = e => {
      e.preventDefault()
      setQueuePage(date, page)
    }
    const isActive = activePage[date] === page


    return (
      <a key={ page } href="#" className="dropdown-item" onClick={ !isActive && setPage }>
        { this.getPaginationButtonLabel(page, date) }
      </a>
    )
  }

  render() {
    const { activePage, months, years } = this.props;

    if (!activePage || (!months.length && !years.length)) {
      return null
    }

    return (
      <nav className="card-footer">
        <div className="row">
          { !!months.length && activePage.year && (
            <div className="col-7 col-lg-12 col-xl-7">
              <div className="dropdown dropup">
                <button
                  className="btn btn-secondary btn-block dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  { this.getPaginationButtonLabel(activePage.month, 'month') }
                </button>
                <div className="dropdown-menu">
                  { months.map(page => this.renderButton(page, 'month')) }
                </div>
              </div>
            </div>
          ) }
          { !!years.length && (
            <div className="col-5 col-lg-12 col-xl-5 mb-lg-2 mb-xl-0">
              <div className="dropdown dropup">
                <button
                  className="btn btn-secondary btn-block dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  { this.getPaginationButtonLabel(activePage.year, 'year') }
                </button>
                <div className="dropdown-menu">
                  { years.map(page => this.renderButton(page, 'year')) }
                </div>
              </div>
            </div>
          ) }
        </div>
      </nav>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  activePage: selectors.getQueuesActivePage,
  months: selectors.getQueuesMonths,
  years: selectors.getQueuesYears,
  queues: selectors.getSiteQueues,
})

export default connect(mapStateToProps, { setQueuePage: actions.setQueuePage })(QueuesPagination)



// WEBPACK FOOTER //
// ./src/components/queues/queues-pagination.js